import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/index';
import { logOutStaffUser } from 'store/slices/staff-user/staff-user-slice';
import { ConfirmationDialog } from 'types/confirmation-dialog/confirmation';

const initialState: ConfirmationDialog = {
    openConfirmationDialog: false,
    textInfo: '',
    handleConfirm: undefined,
    parameters: undefined,
};

const confirmationDialogSlice = createSlice({
    name: 'confirmationDialog',
    initialState,
    reducers: {
        openConfirmationDialogs: (
            state,
            action: PayloadAction<ConfirmationDialog>,
        ) => {
            state.openConfirmationDialog = true;
            state.textInfo = action.payload.textInfo;
            state.parameters = action.payload.parameters;
            state.handleConfirm = action.payload.handleConfirm;
        },
        closeConfirmationDialog: (state) => {
            state.openConfirmationDialog = false;
        },
    },
    extraReducers: (builder) =>
        builder.addCase(logOutStaffUser, () => initialState),
});

export const { openConfirmationDialogs, closeConfirmationDialog } =
    confirmationDialogSlice.actions;

export const selectConfirmationDialogOptions = (state: RootState) =>
    state.confirmationDialog;

export default confirmationDialogSlice.reducer;
